import { FiSearch, FiX } from "react-icons/fi";

const usageOptions = [{ value: "all", label: "All tags", key: "total" }, { value: "used", label: "In use", key: "used" }, { value: "unused", label: "Unused", key: "unused" }];
export default function TagToolbar({ filters, counts, loading, changeFilter }) {
	return <div className="tag-toolbar">
		<div className="tag-usage-filters" role="group" aria-label="Filter tags by usage">
			{usageOptions.map(({ value, label, key }) => <button key={value} type="button" aria-pressed={filters.usage === value}
				onClick={() => changeFilter("usage", value)}>
				{label}<span>{loading || counts[key] == null ? "—" : counts[key].toLocaleString()}</span>
			</button>)}
		</div>
		<div className="tag-toolbar-controls">
			<div className="tag-search"><FiSearch aria-hidden="true" />
				<label htmlFor="tag-search" className="sr-only">Search tags</label>
				<input id="tag-search" type="search" value={filters.search} placeholder="Search by tag name…" onChange={(event) => changeFilter("search", event.target.value)} />
				{filters.search && <button type="button" aria-label="Clear tag search" onClick={() => changeFilter("search", "")}><FiX aria-hidden="true" /></button>}
			</div>
			<div className="tag-sort"><label htmlFor="tag-sort">Sort by</label>
				<select id="tag-sort" value={filters.sort} onChange={(event) => changeFilter("sort", event.target.value)}>
					<option value="name">Name (A–Z)</option><option value="usage">Most used</option><option value="newest">Newest first</option>
				</select>
			</div>
		</div>
	</div>;
}
